<template>
  <div class="mx-auto row col-12 bg-secondary-1 px-1 m-0">
    <div class="col d-flex align-items-center bg-white my-2 mx-1 px-5 py-3">
      <div class="custom-circle-loader-container d-flex align-items-center">
        <circle-loader
          circle-class="custom-circle-loader"
          :inner-text="`${catalog.pendings}%`"
          loader-color="#FDAC41"
          :percentage="catalog.pendings"
        />
      </div>
      <div class="text-dark-midnight">Cuestionarios Pendientes</div>
    </div>
    <div class="col d-flex align-items-center bg-white my-2 mx-1 px-5 py-3">
      <div class="custom-circle-loader-container d-flex align-items-center">
        <circle-loader
          circle-class="custom-circle-loader"
          :inner-text="`${catalog.completed}%`"
          :percentage="catalog.completed"
        />
      </div>
      <div class="text-dark-midnight">Cuestionarios Completados</div>
    </div>
    <div class="col d-flex align-items-center bg-white my-2 mx-1 px-5 py-3">
      <div class="row">
        <div class="col-12 counter">
          {{ catalog.totalCompleted | formatNumber }}
        </div>
        <div class="col-12 text-dark-midnight">
          Cantidad de Cuestionarios Completados
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import CircleLoader from '@/components/common/loaders/CircleLoader';

export default {
  name: 'QuestionnaireStatusBar',
  components: {
    CircleLoader,
  },
  props: {
    catalog: {
      type: Object,
      default: () => {},
    },
  },
};
</script>
<style lang="scss" scoped>
@import '@/shared/scss/config/_colors.scss';
@import '@/shared/scss/config/_fonts.scss';

.custom-circle-loader-container {
  height: 60px;
  width: 60px;
}
::v-deep .percentage {
  font-family: 'Lato', sans-serif;
  font-size: map-get($fontsSize, 'font-11');
  color: map-get($colors, 'black');
}
.text-dark-midnight {
  color: map-get($colors, 'dark-midnight');
  font-size: map-get($fontsSize, 'font-14');
}
.counter {
  font-family: 'Lato', Black;
  font-size: map-get($fontsSize, 'font-20');
}
::v-deep .percentage {
  font-size: 0.6em !important;
}
</style>
